<div class="relative flex flex-col items-start h-full">
  <flx-ai-preview-area-header
    [title]="title()"
    [hasInfoButton]="hasInfoButton()"
  />

  <div
    [class.p-10]="!ignorePadding()"
    class="preview-area-bg h-full w-full -mt-[2px] p-10 bg-blue-50 border-2 border-blue-400 border-dashed rounded"
  >
    <div class="h-full w-full">
      <ng-content class="h-full w-full" />
    </div>
  </div>
</div>
